export default {
  '请输入邮箱smtp': '请输入邮箱smtp',
  '修改': '修改',
  '退出登录': '退出登录',
  '状态': '状态',
  '修改成功': '修改成功',
  '清空数据': '清空数据',
  '强退': '强退',
  '收起': '收起',
  '登录地点': '登录地点',
  '保存': '保存',
  '可以省略，省略后默认为邮箱账号smtp.邮箱后缀,例如：邮箱账号为：zbtech@163.com，smtp为smtp.163.com': '可以省略，省略后默认为邮箱账号smtp.邮箱后缀,例如：邮箱账号为：zbtech@163.com，smtp为smtp.163.com',
  '用户昵称': '用户昵称',
  '清空': '清空',
  '请求参数': '请求参数',
  '通知': '通知',
  '操作信息': '操作信息',
  '此操作将会清空所有调度日志数据项': '此操作将会清空所有调度日志数据项',
  '邮箱账号不能为空': '邮箱账号不能为空',
  '添加字典类型': '添加字典类型',
  '邮件密匙ID': '邮件密匙ID',
  '失败': '失败',
  '邮件AccessKeyId': '邮件AccessKeyId',
  '操作': '操作',
  '系统模块': '系统模块',
  '登录信息': '登录信息',
  '请输入内容': '请输入内容',
  '否': '否',
  '发送邮箱账号': '发送邮箱账号',
  '其他': '其他',
  '是': '是',
  '审核失败': '审核失败',
  '列展开/排序': '列展开/排序',
  '富文本': '富文本',
  '登录时间': '登录时间',
  '男': '男',
  '腾讯云': '腾讯云',
  '访问编号': '访问编号',
  '请求地址': '请求地址',
  '审核状态': '审核状态',
  '展开': '展开',
  '刷新成功': '刷新成功',
  '操作日期': '操作日期',
  '参数类型': '参数类型',
  '腾讯邮件': '腾讯邮件',
  '邮箱密码不能为空': '邮箱密码不能为空',
  '切为全屏': '切为全屏',
  '当前选中编号为': '当前选中编号为',
  '发送邮箱smtp': '发送邮箱smtp',
  '的数据': '的数据',
  '操作人员': '操作人员',
  '删除': '删除',
  '刷新缓存': '刷新缓存',
  '重置': '重置',
  '公告': '公告',
  '主机': '主机',
  '昵称': '昵称',
  '请输入账号': '请输入账号',
  '参数主键': '参数主键',
  '此操作将会清空所有操作日志数据项': '此操作将会清空所有操作日志数据项',
  '密钥SECRET': '密钥SECRET',
  '此操作将导出当前条件下所有数据而非选中数据': '此操作将导出当前条件下所有数据而非选中数据',
  '条': '条',
  '此操作将会清空所有登录日志数据项': '此操作将会清空所有登录日志数据项',
  '审核失败原因': '审核失败原因',
  '注销时间': '注销时间',
  '参数名称': '参数名称',
  '用户名称': '用户名称',
  '解锁': '解锁',
  '新增成功': '新增成功',
  '操作状态': '操作状态',
  '共': '共',
  '输入框': '输入框',
  '女': '女',
  '文本域': '文本域',
  '导出': '导出',
  '请输入': '请输入',
  '取消': '取消',
  '不能为空': '不能为空',
  '日志编号': '日志编号',
  '系统内置': '系统内置',
  '当前选中字典编号为': '当前选中字典编号为',
  '个人设置': '个人设置',
  '阿里云': '阿里云',
  '注销原因': '注销原因',
  '邮件RegionId': '邮件RegionId',
  '成功': '成功',
  '浏览器': '浏览器',
  '字典名称': '字典名称',
  '登录地址': '登录地址',
  '审核人': '审核人',
  '发送邮箱密码': '发送邮箱密码',
  '登录状态': '登录状态',
  '添加参数': '添加参数',
  '待审核': '待审核',
  '审核时间': '审核时间',
  '查询': '查询',
  '联系电话': '联系电话',
  '修改字典类型': '修改字典类型',
  '是否确认清空?': '是否确认清空?',
  '接口信息': '接口信息',
  '参数键值': '参数键值',
  '请求方式': '请求方式',
  '操作方法': '操作方法',
  '字典编号': '字典编号',
  '生日': '生日',
  '参数键名': '参数键名',
  '详细': '详细',
  '本地邮件': '本地邮件',
  '阿里邮件': '阿里邮件',
  '授权': '授权',
  '生成代码': '生成代码',
  '操作系统': '操作系统',
  '审核成功': '审核成功',
  '使用状态': '使用状态',
  '个人中心': '个人中心',
  '禁用': '禁用',
  '备注': '备注',
  '操作模块': '操作模块',
  '邮箱': '邮箱',
  '启用': '启用',
  '操作类型': '操作类型',
  '区域ID': '区域ID',
  '新增': '新增',
  '导入': '导入',
  '邮件AccessKeySecret': '邮件AccessKeySecret',
  '修改参数': '修改参数',
  '是否确认导出?': '是否确认导出?',
  '查看更多': '查看更多',
  '列排序需拖动名称': '列排序需拖动名称',
  '性别': '性别',
  '字典类型': '字典类型',
  '请输入密码': '请输入密码',
  '创建时间': '创建时间',
  '确认删除所选中数据?': '确认删除所选中数据?',
  '操作地点': '操作地点',
  '清空成功': '清空成功',
  '删除成功': '删除成功',
  '提示': '提示',
  '确定注销并退出系统吗？': '确定注销并退出系统吗？',
  '确定': '确定',
  '密码登录': '密码登录',
  '普朗思后台管理系统': '普朗思后台管理系统',
  '退出全屏': '退出全屏',
  '全选/不选': '全选/不选',
  '点击选择显示数据项，调整数据项顺序': '点击选择显示数据项，调整数据项顺序',
  '数据写入': '数据写入',
  '设备标识': '设备标识',
  '参数': '参数',
  '写入值': '写入值',
  '请选择': '请选择',

  '手机号码': '手机号码',
  '添加用户': '添加用户',
  '取消批量授权': '取消批量授权',
  '返回': '返回',
  '取消授权': '取消授权',
  '手机': '手机',
  '确认要取消该用户的角色吗?': '确认要取消该用户的角色吗?',
  '当前选中用户': '当前选中用户',
  '取消授权成功': '取消授权成功',
  '是否取消选中用户授权数据项?': '是否取消选中用户授权数据项?',
  '角色名': '角色名',
  '权限字符': '权限字符',
  '确认': '确认',
  '停用': '停用',
  '的角色吗?': '的角色吗?',
  '更多': '更多',
  '脱敏权限': '脱敏权限',
  '数据权限': '数据权限',
  '分配用户': '分配用户',
  '角色编号': '角色编号',
  '权限标识': '权限标识',
  '排序': '排序',
  '确认要"': '确认要"',
  '"角色吗？': '"角色吗？',
  '关闭': '关闭',
  '异常': '异常',
  '角色名称': '角色名称',
  '角色标识': '角色标识',
  '权限范围': '权限范围',
  '展开/折叠': '展开/折叠',
  '全选/全不选': '全选/全不选',
  '父子联动': '父子联动',
  '当勾选项为空时方可切换模式，可以点击”全不选“后再次切换。': '当勾选项为空时方可切换模式，可以点击”全不选“后再次切换。',
  '全部数据权限': '全部数据权限',
  '自定义数据权限': '自定义数据权限',
  '本部门数据权限': '本部门数据权限',
  '本部门及以下数据权限': '本部门及以下数据权限',
  '仅本人数据权限': '仅本人数据权限',
  '分配数据权限': '分配数据权限',
  '超级管理员角色信息 不可更改': '超级管理员角色信息 不可更改',
  "控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasRole('admin')`)": "控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasRole('admin')`)",
  '菜单权限': '菜单权限',
  '顺序': '顺序',
  '添加角色': '添加角色',
  '修改角色': '修改角色',
  '列名': '列名',
  '列名描述': '列名描述',
  '是否脱敏': '是否脱敏',
  '脱敏方向': '脱敏方向',
  '从右向左': '从右向左',
  '从左向右': '从左向右',
  '起始位置': '起始位置',
  '脱敏字符数': '脱敏字符数',
  '设置脱敏权限': '设置脱敏权限',
  '操作成功！': '操作成功！',
  '选择用户': '选择用户',
  '手机号': '手机号',
  '请选择状态': '请选择状态',
  '项目': '项目',
  '用户编号': '用户编号',
  '用户名': '用户名',
  '重置密码': '重置密码',
  '分配角色': '分配角色',
  '的用户吗?': '的用户吗?',
  '密码': '密码',
  '岗位': '岗位',
  '角色': '角色',
  '用户密码长度必须介于 5 和 20 之间': '用户密码长度必须介于 5 和 20 之间',
  '请正确填写邮箱地址': '请正确填写邮箱地址',
  '请正确填写手机号': '请正确填写手机号',
  '修改用户': '修改用户',
  '新增用户': '新增用户',
  '请输入搜索内容': '请输入搜索内容',
  '新密码': '新密码',
  '确认密码': '确认密码',
  '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种': '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种',
  '请再次输入新密码确认': '请再次输入新密码确认',
  '两次输入的密码不一致': '两次输入的密码不一致',
  '重置成功': '重置成功',
  '菜单名称': '菜单名称',
  'DIY页面': 'DIY页面',
  '图标': '图标',
  '组件路径': '组件路径',
  '上级菜单': '上级菜单',
  '菜单类型': '菜单类型',
  '目录': '目录',
  '菜单': '菜单',
  'DIY菜单': 'DIY菜单',
  '按钮': '按钮',
  '选择图标': '选择图标',
  '是否外链': '是否外链',
  '选择是外链则路由地址需要以`http(s)://`开头': '选择是外链则路由地址需要以`http(s)://`开头',
  '路由地址': '路由地址',
  '访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头': '访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头',
  '访问的组件路径，如：`system/user/index`，默认在`views`目录下': '访问的组件路径，如：`system/user/index`，默认在`views`目录下',
  "控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasPermi('system:user:list')`)": "控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasPermi('system:user:list')`)",
  '是否显示': '是否显示',
  '选择隐藏则路由将不会出现在侧边栏，但仍然可以访问': '选择隐藏则路由将不会出现在侧边栏，但仍然可以访问',
  '选择停用则路由将不会出现在侧边栏，也不能被访问': '选择停用则路由将不会出现在侧边栏，也不能被访问',
  '是否缓存': '是否缓存',
  '选择是则会被`keep-alive`缓存，需要匹配组件的`name`和地址保持一致，仅在多页签下有效。': '选择是则会被`keep-alive`缓存，需要匹配组件的`name`和地址保持一致，仅在多页签下有效。',
  '缓存': '缓存',
  '不缓存': '不缓存',
  '添加菜单': '添加菜单',
  '修改菜单': '修改菜单',
  // 这里是新增
  "部件名称": "部件名称",
  "状态": "状态",
  "差值": "差值",
  "设备地址": "设备地址",
  "不等于": "不等于",
  "BOM维护": "BOM维护",
  "菜单管理": "菜单管理",
  "获取验证码": "获取验证码",
  "告警设备": "告警设备",
  "最后登录IP": "最后登录IP",
  "域名信息": "域名信息",
  "所属模板": "所属模板",
  "描述": "描述",
  "设备分配": "设备分配",
  "当前密码强度": "当前密码强度",
  "与": "与",
  "已分配": "已分配",
  "用户动态": "用户动态",
  "用户昵称": "用户昵称",
  "用户管理": "用户管理",
  "已处理工单": "已处理工单",
  "控制规则": "控制规则",
  "验证码登录": "验证码登录",
  "或": "或",
  "SMTP主机地址": "SMTP主机地址",
  "登录账号": "登录账号",
  "用户名": "用户名",
  "数据删除后无法恢复，请确认": "数据删除后无法恢复，请确认",
  "确定要禁用该用户吗": "确定要禁用该用户吗",
  "科创能采集控制通用平台": "科创能采集控制通用平台",
  "操作": "操作",
  "处理人": "处理人",
  "否": "否",
  "请选择": "请选择",
  "工单来源": "工单来源",
  "是": "是",
  "登录": "登录",
  "报警记录": "报警记录",
  "设备状态": "设备状态",
  "暂无数据": "暂无数据",
  "值": "值",
  "配件类型": "配件类型",
  "处理图片": "处理图片",
  "正常状态": "正常状态",
  "科创能采集控制": "科创能采集控制",
  "文件": "文件",
  "手机": "手机",
  "处理人姓名": "处理人姓名",
  "部件型号": "部件型号",
  "升级": "升级",
  "请输入正确的手机号或邮箱": "请输入正确的手机号或邮箱",
  "通讯协议": "通讯协议",
  "模板名称": "模板名称",
  "大于": "大于",
  "数据设置": "数据设置",
  "删除": "删除",
  "确定要删除该用户吗": "确定要删除该用户吗",
  "离线状态": "离线状态",
  " 设备状态": " 设备状态",
  "设备位置": "设备位置",
  "离线数": "离线数",
  "小于": "小于",
  "待处理工单": "待处理工单",
  "告警": "告警",
  "昵称": "昵称",
  "存储时长": "存储时长",
  "请输入昵称": "请输入昵称",
  "告警规则": "告警规则",
  "数据导出": "数据导出",
  "更换时间": "更换时间",
  "邮箱不能为空": "邮箱不能为空",
  "告警组名称": "告警组名称",
  "等于": "等于",
  "在线设备": "在线设备",
  "离线": "离线",
  "安全设置": "安全设置",
  "信息概览": "信息概览",
  "系统管理": "系统管理",
  "是否接收告警邮件": "是否接收告警邮件",
  "最后登录时间": "最后登录时间",
  "请输入": "请输入",
  "取消": "取消",
  "设备上报": "设备上报",
  "忘记密码": "忘记密码",
  "厂家": "厂家",
  "最小值": "最小值",
  "证书信息": "证书信息",
  "请输入地址查询": "请输入地址查询",
  "规则阈值条件": "规则阈值条件",
  "设备编号": "设备编号",
  "文本": "文本",
  "s后重新获取": "s后重新获取",
  "设备详情": "设备详情",
  "条数据": "条数据",
  "SMTP配置": "SMTP配置",
  "已取消": "已取消",
  "请阅读并同意《用户注册协议》与《隐私协议》": "请阅读并同意《用户注册协议》与《隐私协议》",
  "查询": "查询",
  "设备编码": "设备编码",
  "系统消息": "系统消息",
  "设备名称": "设备名称",
  "单位": "单位",
  "采集控制平台": "采集控制平台",
  "历史记录": "历史记录",
  "在线": "在线",
  "请正确填写邮箱地址": "请正确填写邮箱地址",
  "设备模板": "设备模板",
  "确认密码": "确认密码",
  "旧密码": "旧密码",
  "分组名称": "分组名称",
  "1个月报警数": "1个月报警数",
  "工单列表": "工单列表",
  "已阅读并同意": "已阅读并同意",
  "在线数量": "在线数量",
  "图片附件": "图片附件",
  "时间": "时间",
  "电子邮件": "电子邮件",
  "20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种": "20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种",
  "请再次输入新密码确认": "请再次输入新密码确认",
  "待处理": "待处理",
  "证书管理": "证书管理",
  "全部设备": "全部设备",
  "选择配件分组": "选择配件分组",
  "数值": "数值",
  "图标": "图标",
  "请输入旧密码": "请输入旧密码",
  "规则名称": "规则名称",
  "备注": "备注",
  "属性类型": "属性类型",
  "系统工具": "系统工具",
  "密码不能为空": "密码不能为空",
  "邮箱": "邮箱",
  "属性标识符": "属性标识符",
  "证书": "证书",
  "提交": "提交",
  "data设置": "data设置",
  "已升级": "已升级",
  "风机信息": "风机信息",
  "端口": "端口",
  "点击选择显示列": "点击选择显示列",
  "配件总数": "配件总数",
  "规则设置": "规则设置",
  "工单设备": "工单设备",
  "请正确填写手机号": "请正确填写手机号",
  "导入": "导入",
  "新增": "新增",
  "确定": "确定",
  "最近上线时间": "最近上线时间",
  "告警历史": "告警历史",
  "在线数": "在线数",
  "性别": "性别",
  "基本设置": "基本设置",
  "密码": "密码",
  "角色": "角色",
  "BOM名称": "BOM名称",
  "手机号": "手机号",
  "确认": "确认",
  "模式配置": "模式配置",
  "设备对应属性编码": "设备对应属性编码",
  "升级管理": "升级管理",
  "请输入手机号或邮箱": "请输入手机号或邮箱",
  "修改": "修改",
  "登录日志": "登录日志",
  "退出登录": "退出登录",
  "配件列表": "配件列表",
  "修改成功": "修改成功",
  "请填写手机号": "请填写手机号",
  "出厂时间": "出厂时间",
  "保存": "保存",
  "设备云端共享": "设备云端共享",
  "历史数据": "历史数据",
  "设备": "设备",
  "报警内容": "报警内容",
  "数据大屏": "数据大屏",
  "两次输入的密码不一致": "两次输入的密码不一致",
  "设备中心": "设备中心",
  "新密码": "新密码",
  "6个月报警数": "6个月报警数",
  "设备列表": "设备列表",
  "配件Key": "配件Key",
  "SMTP主机": "SMTP主机",
  "帮助文档": "帮助文档",
  "阈值": "阈值",
  "PWM": "PWM",
  "存储设定": "存储设定",
  "账户密码": "账户密码",
  "版本号": "版本号",
  "已分组配件": "已分组配件",
  "SMTP端口号": "SMTP端口号",
  "基本信息": "基本信息",
  "驾驶舱": "驾驶舱",
  "离线设备": "离线设备",
  "下发": "下发",
  "报警时间": "报警时间",
  "排序": "排序",
  "编辑": "编辑",
  "规则数": "规则数",
  "男": "男",
  "正常": "正常",
  "强": "强",
  "列表": "列表",
  "用户列表": "用户列表",
  "未分配": "未分配",
  "配件告警组": "配件告警组",
  "序号": "序号",
  "已处理报警": "已处理报警",
  "请输入验证码": "请输入验证码",
  "数据类型": "数据类型",
  "工单说明": "工单说明",
  "重置": "重置",
  "数据位号": "数据位号",
  "运行时间": "运行时间",
  "刷新页面": "刷新页面",
  "配件": "配件",
  "模板总数": "模板总数",
  "证书数量": "证书数量",
  "处理人联系方式": "处理人联系方式",
  "条": "条",
  "代码生成": "代码生成",
  "工单管理": "工单管理",
  "提示": "提示",
  "在线状态": "在线状态",
  "配件数": "配件数",
  "报警": "报警",
  "设备导入": "设备导入",
  "指定范围": "指定范围",
  "公网": "公网",
  "女": "女",
  "隐私协议": "隐私协议",
  "导出": "导出",
  "用户注册协议": "用户注册协议",
  "所属证书": "所属证书",
  "待处理报警异常": "待处理报警异常",
  "报警值": "报警值",
  "最大值": "最大值",
  "最后上报时间": "最后上报时间",
  "属性备注": "属性备注",
  "最近离线时间": "最近离线时间",
  "手机号不能为空": "手机号不能为空",
  "请输入帐户名": "请输入帐户名",
  "请输入新密码": "请输入新密码",
  "账号": "账号",
  "联系人": "联系人",
  "所含配件": "所含配件",
  "保密": "保密",
  "本地": "本地",
  "处理": "处理",
  "未分组配件": "未分组配件",
  "详情": "详情",
  "升级状态": "升级状态",
  "更换次数": "更换次数",
  "请填写手机号邮箱": "请填写手机号邮箱",
  "通讯类型": "通讯类型",
  "当前账号无菜单权限，请联系管理员": "当前账号无菜单权限，请联系管理员",
  "系统接口": "系统接口",
  "小数位数": "小数位数",
  "返回": "返回",
  "问题描述": "问题描述",
  "设备数据单位": "设备数据单位",
  "当前有": "当前有",
  "选择未分组配件": "选择未分组配件",
  "已处理": "已处理",
  "确定注销并退出系统吗": "确定注销并退出系统吗",
  "是否取消该订单,请确认": "是否取消该订单,请确认",
  "清除缓存": "清除缓存",
  "未分组": "未分组",
  "处理说明": "处理说明",
  "设备信息": "设备信息",
  "云端下发": "云端下发",
  "切换全屏": "切换全屏",
  "风机名称": "风机名称",
  "报警数": "报警数",
  "风机模板": "风机模板",
  "证书名称": "证书名称",
  "主机地址": "主机地址",
  "配件名称": "配件名称",
  "条件": "条件",
  "更新记录": "更新记录",
  "属性名称": "属性名称",
  "文件上传": "文件上传",
  "周期": "周期",
  "设备总数": "设备总数",
  "批次": "批次",
  "port号": "port号",
  "禁用": "禁用",
  "查看": "查看",
  "重置密码": "重置密码",
  "服务器地址": "服务器地址",
  "上级用户": "上级用户",
  "属性展示名称": "属性展示名称",
  "固件列表": "固件列表",
  "退出全屏": "退出全屏",
  "工作台": "工作台",
  "设备协议": "设备协议",
  "告警数": "告警数",
  "设备类型": "设备类型",
  "看板": "看板",
  "请确认密码": "请确认密码",
  "报警状态": "报警状态",
  "版本名称": "版本名称",
  "枚举": "枚举",
  "今日报警数": "今日报警数",
  "联系方式": "联系方式",
  "配件详情": "配件详情",
  "工单状态": "工单状态",
  "标识符": "标识符",
  "所属配件": "所属配件",
  "最后上传时间": "最后上传时间",
  "列表详情": "列表详情",
  "数据": "数据",
  "待升级": "待升级",
  "云端私有": "云端私有",
  "加载更多": "加载更多",
  "处理备注": "处理备注",
  "登录密码": "登录密码",
  "请输入密码": "请输入密码",
  "创建时间": "创建时间",
  "角色管理": "角色管理",
  "风机型号": "风机型号",
  "我的资源": "我的资源",
  "密码登录": "密码登录",
  "欢迎来到": "欢迎来到",
  "我的工单": "我的工单",
  "采集控制通用平台": "采集控制通用平台",
  "请完成安全验证": "请完成安全验证",
  "向右滑动完成验证": "向右滑动完成验证",
  "成功": "成功",
  "创建成功": "创建成功",
  "编辑成功": "编辑成功",
  "保存成功": "保存成功",
  "验证成功": "验证成功",
  "验证失败": "验证失败",
  "您确定要导出所选证书数据信息吗": "您确定要导出所选证书数据信息吗",
  "处理时间": "处理时间",
  "处理内容": "处理内容",
  "选择设备": "选择设备",
  "选择导出时间": "选择导出时间",
  "下发证书": "下发证书",
  "是否取消该订单": "是否取消该订单",
  "请确认": "请确认",
  "确定要": "确定要",
  "该用户吗": "该用户吗",
  "启用": "启用",
  "上传中...": "上传中...",
  "基础数据上传": "基础数据上传",
  "请刷新页面后重新选择文件！": "请刷新页面后重新选择文件！"
}
